/**
 * @public
 */
export var baseClassName = 'wind-rc-truncate';
/**
 * @public
 */

export var mainClassName = "".concat(baseClassName, "__truncated");
/**
 * @public
 */

export var omissionClassName = "".concat(baseClassName, "__omission");
/**
 * @public
 */

export var tooltipPopupClassName = "".concat(baseClassName, "__tooltip-popup");
/**
 * @public
 */

export var wrapperClassName = "".concat(baseClassName, "__wrapper");
/**
 * @public
 */

export var originalContentClassName = "".concat(baseClassName, "__original-content");
/**
 * 见 Balloon（Tooltip）组件文档
 * @public
 */